"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AsyncSelect = exports.CreatableSelect = exports.Select = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_select_1 = __importStar(require("react-select"));
var creatable_1 = __importDefault(require("react-select/creatable"));
var async_1 = __importDefault(require("react-select/async"));
var classnames_1 = __importDefault(require("classnames"));
require("./Select.css");
var R = __importStar(require("../../utils/ramda"));
var MDIcon_1 = require("../../components/MDIcon");
var makeClassName = function (name, error, focus) {
  return (0, classnames_1.default)(name, "vsx-react-select", error && "vsx-react-select-error", focus && "focus-styles");
};
var customStyles = {};
var classNamesConfig = {
  container: R.always("vsx-react-select-control"),
  multiValue: R.always("vsx-react-select-multivalue"),
  multiValueRemove: R.always("vsx-react-select-multivalue-remove"),
  control: function (state) {
    return (0, classnames_1.default)("vsx-react-select-control", state.isFocused && "vsx-react-select-control-focused", state.isDisabled && "vsx-react-select-control-disabled");
  },
  input: R.always("vsx-react-select-input"),
  valueContainer: R.always("vsx-react-select-value-container"),
  indicatorsContainer: R.always("vsx-react-select-indicators-container"),
  indicatorSeparator: R.always("vsx-react-select-indicator-separator"),
  dropdownIndicator: R.always("vsx-react-select-dropdown-indicator"),
  clearIndicator: R.always("vsx-react-select-clear-indicator"),
  menu: R.always("vsx-react-select-menu"),
  menuList: R.always("vsx-react-select-menu-list"),
  option: function (o) {
    return o.isSelected ? "vsx-react-select-option-selected" : "";
  }
};
var customTheme = function (theme) {
  return __assign(__assign({}, theme), {
    colors: __assign(__assign({}, theme.colors), {
      primary25: "#f5f5f5",
      primary50: "#dcdcdc",
      primary: "#dcdcdc"
    })
  });
};
(0, MDIcon_1.preloadIcons)("close", "chevron-down", "loading");
var customComponents = function (menuPlacement) {
  return {
    ClearIndicator: function (_a) {
      var props = __rest(_a, []);
      return (0, jsx_runtime_1.jsx)(react_select_1.components.ClearIndicator, __assign({}, props, {
        children: (0, jsx_runtime_1.jsx)(MDIcon_1.MDIcon, {
          align: "middle",
          size: "1.3em",
          className: "vsx-react-select-clear-indicator",
          icon: "close"
        })
      }));
    },
    DropdownIndicator: function (_a) {
      var props = __rest(_a, []);
      return (0, jsx_runtime_1.jsx)(react_select_1.components.DropdownIndicator, __assign({}, props, {
        children: (0, jsx_runtime_1.jsx)(MDIcon_1.MDIcon, {
          align: "middle",
          size: "1.5em",
          className: "vsx-react-select-dropdown-indicator",
          icon: menuPlacement === "top" ? "chevron-up" : "chevron-down"
        })
      }));
    },
    MultiValueRemove: function (_a) {
      var props = __rest(_a, []);
      return (0, jsx_runtime_1.jsx)(react_select_1.components.MultiValueRemove, __assign({}, props, {
        children: (0, jsx_runtime_1.jsx)(MDIcon_1.MDIcon, {
          className: "vsx-react-select-multivalue-remove",
          icon: "close"
        })
      }));
    },
    IndicatorSeparator: function (_) {
      return null;
    }
    // LoadingIndicator: ({ ...props }: any) => (
    //   <MDIcon align="middle" size="1.5em" className="vsx-react-select-loading-indicator" animation="spin" icon="loading" />
    // )
  };
};

var Select = function (_a) {
  var className = _a.className,
    focusStyles = _a.focusStyles,
    error = _a.error,
    disabled = _a.disabled,
    isDisabled = _a.isDisabled,
    components = _a.components,
    restProps = __rest(_a, ["className", "focusStyles", "error", "disabled", "isDisabled", "components"]);
  return (0, jsx_runtime_1.jsx)(react_select_1.default, __assign({
    className: makeClassName(className, error, focusStyles),
    classNames: classNamesConfig,
    styles: customStyles,
    components: __assign(__assign({}, customComponents(restProps.menuPlacement)), components),
    isDisabled: disabled || isDisabled,
    theme: customTheme
  }, restProps));
};
exports.Select = Select;
var CreatableSelect = function (_a) {
  var className = _a.className,
    error = _a.error,
    disabled = _a.disabled,
    components = _a.components,
    focusStyles = _a.focusStyles,
    restProps = __rest(_a, ["className", "error", "disabled", "components", "focusStyles"]);
  return (0, jsx_runtime_1.jsx)(creatable_1.default, __assign({
    className: makeClassName(className, error, focusStyles),
    classNames: classNamesConfig,
    styles: customStyles,
    components: __assign(__assign({}, customComponents(restProps.menuPlacement)), components),
    isDisabled: disabled,
    theme: customTheme
  }, restProps));
};
exports.CreatableSelect = CreatableSelect;
var AsyncSelect = function (_a) {
  var className = _a.className,
    error = _a.error,
    disabled = _a.disabled,
    components = _a.components,
    focusStyles = _a.focusStyles,
    restProps = __rest(_a, ["className", "error", "disabled", "components", "focusStyles"]);
  return (0, jsx_runtime_1.jsx)(async_1.default, __assign({
    className: makeClassName(className, error, focusStyles),
    classNames: classNamesConfig,
    isDisabled: disabled,
    styles: customStyles,
    components: __assign(__assign({}, customComponents(restProps.menuPlacement)), components),
    theme: customTheme
  }, restProps));
};
exports.AsyncSelect = AsyncSelect;